<template>
  <div class="user-pop">
    <div class="pop" @click="handleClose"></div>
    <div class="user_input">
      <div class="dialog-con">
        <div class="con-top">
          <img :src="userInfo && userInfo.headPicUrl" class="top-cover" alt="" />
          <div class="top-txt">{{ userInfo && userInfo.realName }}</div>
          <div class="top-close" @click="handleClose">取消</div>
        </div>
        <div class="input">
          <van-field
            v-model="message"
            rows="3"
            type="textarea"
            maxlength="100"
            placeholder="请输入你的评论"
          />
        </div>
        <div v-if="fileList[0]" class="comment-imgs">
          <img
            v-if="fileList[0].url"
            @click="handleShowImg(fileList[0])"
            :src="fileList[0].url"
            class="commimg"
            alt=""
          />
          <img src="@/assets/images/zone/train_cnacel.png" @click="handleDel" class="icon-del" alt="">
          <div class="custom-mask" @click="hidePreviewIfMaskClicked">
            <van-image-preview
              ref="imagePreview"
              v-model="showimg"
              :images="[fileList[0].url]"
              :closeable="true"
            />
          </div>
        </div>
        <van-uploader
          v-else
          v-model="fileList"
          :max-count="1"
          accept="image/*"
          :beforeRead="beforeRead"
        />
        <div class="btn">
          <van-checkbox v-if="(`${roles.peSign}` === '1') && detailData.voteListSelectedDTOS && detailData.voteListSelectedDTOS.length > 0" :icon-size="18" checked-color="#EB1700" v-model="checked">是否为公布答案</van-checkbox>
          <span v-else></span>
          <div class="submit" @click="handleSubmit">提交</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { commentApi, uploadPathFile } from '@/api/zone'
export default {
  props: {
    detailData: {},
    files: []
  },
  data() {
    return {
      message: '',
      commentableId: '',
      targetContent: '',
      fileList: [],
      checked: false,
      showimg: false
    }
  },
  //   "`${detailData.userIdentity}` === '2'"
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    },
    roles() {
      return sessionStorage.getItem('roleResult') ? JSON.parse(sessionStorage.getItem('roleResult')) : {}
    }
  },
  watch: {
    detailData(newval) {
      this.details = newval
    },
  },
  mounted() {
  },
  methods: {
    handleShowImg(item) {
      this.showimg = !this.showimg
    },
    // 点击关闭
    hidePreviewIfMaskClicked (event) {
      // 判断点击是否发生在预览图片本身之外
      if (event.target.classList.contains('van-image-preview__swipe-item')) {
        this.showimg = false
        document.removeEventListener('mousedown', this.handleMouseDown)
      }
    },
    handleDel() {
      this.fileList = []
    },
    beforeRead (file) {
      let formData = new FormData()
      formData.append('number', this.fileList.length + 1 + '')
      formData.append('mainId', '')
      formData.append('file', file)
      uploadPathFile(formData).then(res => {
        this.fileList.push(res.data)
      }).catch((err) => {
        if (`${err.code}` !== '0') {
          this.$toast('上传失败')
          this.videoObj = {}
        }
      })
    },
    handleClose() {
      this.$parent.show = false
    },
    handleSubmit() {
      // console.log(this.files, this.detailData.liveDTO, this.detailData, this.detailData.coverInfo.url)
      if (this.message.length <= 0) {
        this.$toast('请输入评论内容！')
        return
      }
      if (this.isLoad) {
        return
      }
      this.isLoad = true
      let params = {
        targetUserId: this.detailData.iepUserDTO.id,
        targetHeadPic: this.detailData.iepUserDTO.headPicUrl,
        targetUserName: this.detailData.iepUserDTO.realName,
        commentableId: this.commentableId
          ? this.commentableId
          : this.detailData.id,
        targetContent: this.targetContent
          ? this.targetContent
          : this.detailData.subjectName,
        userId: this.userInfo.id,
        userHeadPic: this.userInfo.headPicUrl,
        userName: this.userInfo.realName,
        content: this.message,
        anonymity: 0,
        // 类型类型1rtc专区2病例交流3评论
        type: this.commentableId ? '3' : '1',
        postbarId: this.$route.query.postId,
        kind: this.detailData.kind,
        commentSysfileId: this.fileList && this.fileList.length > 0 ? this.fileList[0].id : ''
      }
      if (this.files && this.files.length > 0) {
        params.cover = this.files[0].url
      } else if (this.detailData.liveDTO && Object.keys(this.detailData.liveDTO).length > 0) {
        params.cover = this.detailData.liveDTO.liveCover
      } else if (this.detailData.coverInfo && Object.keys(this.detailData.coverInfo).length > 0) {
        params.cover = this.detailData.coverInfo.url
      }
      if ((`${this.roles.peSign}` === '1') && this.detailData.voteListSelectedDTOS && this.detailData.voteListSelectedDTOS.length > 0) {
        params.isAnswer = this.checked ? 1 : 0
      }
      commentApi(params)
        .then((res) => {
          this.isLoad = false
          if (`${res.code}` === '0') {
            this.$toast('评论成功')
            this.$parent.show = false
            this.message = ''
            params.id = res.data
            this.checked = false
            this.fileList = []
            this.$emit('handleEmit')
          }
        })
        .catch((err) => {
          this.isLoad = false
          this.$toast(err.msg)
        })
    },
  },
}
</script>
<style lang="less" scoped>
.user-pop {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;

  .pop {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 999;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.7);
  }
}

.user_input {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 375px;
  height: 270px;
  background: #ffffff;
  z-index: 999;

  .dialog-con {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;

    .con-top {
      display: flex;
      align-items: center;
      padding: 0 20px;
      height: 50px;

      .top-cover {
        width: 32px;
        height: 32px;
        margin-right: 5px;
        border-radius: 50%;
        display: block;
      }

      .top-txt {
        flex: 1;
        font-size: 14px;
        color: #000000;
      }

      .top-close {
        font-size: 14px;
        color: #000000;
      }
    }

    .input {
      padding: 0 20px;
      box-sizing: border-box;

      .van-cell {
        background: #f5f5f5;
        border-radius: 8px;
      }
    }
    .comment-imgs {
      margin: 10px 0;
      padding: 0 20px;
      width: 50px;
      height: 50px;
      position: relative;
      .icon-del {
        position: absolute;
        width: 12px;
        height: 12px;
        right: 10px;
        top: -4px;
      }
      .commimg {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    /deep/ .van-uploader {
      margin: 10px 0;
      padding: 0 20px;
      width: 50px;
      height: 50px;
      .van-uploader__upload {
        width: 50px;
        height: 50px;
        margin-right: 0;
        margin-bottom: 0;
      }
      .van-uploader__preview {
          margin: 0;
          .van-image {
              width: 50px;
              height: 50px;
          }
      }
    }

    .btn {
      width: 100%;
      padding: 0 20px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: #f3f5f7;
      height: 44px;
      /deep/.van-checkbox__label {
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 400;
          font-size: 14px;
          color: #000000;
      }
      .submit {
        display: inline-block;
        width: 56px;
        height: 27px;
        background: #EB1700;
        box-shadow: 0px 2px 4px 0px rgba(255, 91, 12, 0.25);
        border-radius: 30px;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 400;
        font-size: 14px;
        color: #ffffff;
        text-align: center;
        line-height: 27px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/RTCZone/compontents/commentDialog.vue